import { Component, forwardRef, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartMetricsEnum } from '../../enums/chart-metrics.enum';
import { ChartDisplayElementModel } from '../../models/chart-display-element.model';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { CheckboxesFieldComponent } from '../../../PageBuilder/components/FormFields/CheckboxesField/checkboxes-field.component';
import { ChartSpecificTypesEnum } from '../../../../Common/Reports/enums/chart-specific-types.enum';

@Component({
    selector: 'agpr-chart-data-checkboxes-field',
    templateUrl: '../../../PageBuilder/components/FormFields/CheckboxesField/checkboxes-field.component.html',
    styleUrls: ['../../../PageBuilder/components/FormFields/CheckboxesField/checkboxes-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ChartDataDisplaySettingsCheckboxFieldComponent)
        }
    ],
    standalone: false
})
export class ChartDataDisplaySettingsCheckboxFieldComponent extends CheckboxesFieldComponent implements OnChanges {

    constructor() {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);

        const displayElement = this.block.displayElement as ChartDisplayElementModel;
        if (displayElement.chartSpecificType === ChartSpecificTypesEnum.COLUMN
        ) {
            this.value = [];
            this.field.options.forEach(option => option.disabled = true);
            displayElement.enableDataDisplaySettings = false;
        } else {
            this.field.options.forEach(option => option.disabled = false);
            displayElement.enableDataDisplaySettings = true;
        }
    }
}
